import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions, Timestamp, WithFieldValue } from "firebase/firestore";
import { Message } from "../types/Message";
import { FirebaseMessage } from "../types/firebase/FirebaseMessage";
import { DateTime } from "luxon";

export const messageConverter: FirestoreDataConverter<Message> = {
    toFirestore(message: Message): DocumentData {
        let data: FirebaseMessage = {
            id: message.id,
            refId: message.refId,
            localId: message.localId,
            replyToId: message.replyToId,
            senderId: message.senderId,
            body: message.body,
            dateSent: Timestamp.fromMillis(message.dateSent.toMillis()),
            dateRead: message.dateRead?.map(v => {
                return {
                    memberIdNumber: v.idNumber,
                    dateRead: Timestamp.fromMillis(v.dateRead.toMillis())
                };
            }),
            type: message.type,
            status: message.status,
        }
        return data;
    },
    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Message {
        const data = snapshot.data(options) as FirebaseMessage;
        return {
            id: data.id,
            refId: data.refId,
            localId: data.localId,
            replyToId: data.replyToId,
            replyTo: undefined,
            senderId: data.senderId,
            sender: undefined,
            body: data.body,
            dateSent: DateTime.fromJSDate(data.dateSent.toDate()),
            dateRead: data.dateRead?.map(v => {
                return {
                    idNumber: v.memberIdNumber,
                    employee: undefined,
                    dateRead: DateTime.fromJSDate(v.dateRead.toDate())
                };
            }),
            type: data.type,
            status: data.status
        };
    }
}